module.exports = "/images/pin-painting.png?927728c1c8806859721206daf92c97e3";